import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
import "./../../bindings/bao-tree";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchTag(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearch/ExpandedTag";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.SelectedAreas = ko.observableArray([]);
    self.AreaName = ko.observable();
    self.AreaId = ko.observable();
    self.AreaId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedOrgUnits = ko.observableArray([]);
    self.OrgUnitName = ko.observable();
    self.OrgUnitId = ko.observable();
    self.OrgUnitId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.AreaId() == null && self.OrgUnitId() == null) {
            return null;
        }
        else {
            return {
                AreaId: JSON.stringify(self.AreaId()),
                OrgUnitId: JSON.stringify(self.OrgUnitId())
            };
        }
    };
    self.init = function () {
        return $.when(self.LoadHtml());
    };
}
export default ExpandedSearchTag;